import QuestionGenerationAPI from '../api/QuestionGenerationAPI';

class QuestionGenerationRepository {
  private questionGenerationApi = new QuestionGenerationAPI();

  public generateQuestions(
    organizationId: string,
    nodeId: string,
    topic: string,
    lessonId: string,
    diffeculty: string,
  ) {
    return this.questionGenerationApi.generateQuestions(
      organizationId,
      nodeId,
      topic,
      lessonId,
      diffeculty,
    );
  }

  public generateChallengeBranchAI(
    organizationId: string,
    lessonId: string,
    videoNodeId: string,
  ) {
    return this.questionGenerationApi.generateChallangeBranchAI(
      organizationId,
      lessonId,
      videoNodeId,
    );
  }
}

export default QuestionGenerationRepository;
